import { z } from "zod";

export const apiErrorSchema = z.object({
  ok: z.literal(false),
  error: z.object({
    code: z.string(),
    message: z.string(),
    fields: z.record(z.string(), z.array(z.string())).default({})
  }),
  meta: z.record(z.string(), z.unknown()).default({})
});

export const envelope = <T extends z.ZodTypeAny>(data: T) =>
  z.object({ ok: z.literal(true), data, meta: z.record(z.string(), z.unknown()).default({}) });

export const pageMetaSchema = z.object({
  page: z.number().optional(),
  page_size: z.number().optional(),
  total: z.number().optional(),
  pages: z.number().optional()
}).passthrough();

export const workflowSchema = z.object({
  id: z.string().nullable(),
  status: z.string(),
  label: z.string(),
  version: z.number(),
  draft_version: z.number().nullable(),
  live_version: z.number().nullable(),
  updated_at: z.string().nullable(),
  allowed_actions: z.array(z.string()),
  review_notice: z.string().nullable().optional()
});

export type WorkflowDto = z.infer<typeof workflowSchema>;
